import {Typography} from "@mui/material"
import {styled} from "@mui/material/styles"

export const Italic = styled("i")`
    font-family: ${({theme}) => `${theme.colours.font.primary.italic.family}, ${theme.colours.font.default}`};
    font-weight: normal;
`
export const List = styled("ul")`
    padding-inline-start: 1.25rem;
`

export const ListItem = styled("li")`
    padding-bottom: 0.75rem;
`

export const NoResultsText = styled(Typography)<{component?: "h1"}>`
    color: ${({theme}) => theme.colours.text.default};
    font-size: 1rem;
    font-family: ${({theme}) => `${theme.colours.font.primary.medium.family}, ${theme.colours.font.default}`};
    font-weight: 600;
    line-height: 1.5;
    letter-spacing: 0.12px;
    margin: 0 0 0.35em;
`

export const SuggestionsText = styled(Typography)`
    color: ${({theme}) => theme.colours.text.default};
    font-size: 0.875rem;
    font-family: ${({theme}) => `${theme.colours.font.primary.medium.family}, ${theme.colours.font.default}`};
    font-weight: 600;
    line-height: 1.5;
    letter-spacing: 0.12px;
    margin: 0 0 0.35em;
`
